const formatPrice = (price, currency)=>{
  return `${currency}${Math.round(parseInt(price))}`
}

export default formatPrice